import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import { Col, Row, Overlay, Popover, Button } from 'bootstrap';
import EventCategorizedShowList from 'shared/components/show/eventCategorizedShowList';
import PureRenderMixin from 'react-addons-pure-render-mixin';

import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';

const defaultPopoverId = 'eventShowMenu';

export default React.createClass({
  mixins: [PureRenderMixin, Reflux.connect(PopoverStore, 'popoverVisibility')],

  displayName: 'EventShowMenu',

  propTypes: {
    popoverId: React.PropTypes.string,
    onShowClick: React.PropTypes.func,
    onEventClick: React.PropTypes.func,
    placement: React.PropTypes.string,
    activeShow: React.PropTypes.object,
    events: React.PropTypes.array,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
      popoverId: defaultPopoverId,
    };
  },

  render() {
    const { caretIcon, popoverId, activeShow, displayNode } = this.props;
    const { popoverVisibility } = this.state;

    const activeText = activeShow
      ? activeShow.get('title')
      : 'Select Show to publish elements to';

    const targetNode = displayNode ? (
      <div ref="target">{displayNode}</div>
    ) : (
      <Button className="event-show-menu__filter-btn" ref="target">
        <span>
          <span className="ge-popover-filter-menu-title">{activeText}</span>{' '}
          {caretIcon}
        </span>
      </Button>
    );

    return (
      <div
        className="ge-filter-wrapper"
        onClick={() => this._togglePopoverVisibility()}
      >
        {targetNode}
        <Overlay
          rootClose
          show={popoverVisibility.get(popoverId)}
          onHide={this._handleHidePopover}
          placement={this.props.placement}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          {this._getPopoverNode()}
        </Overlay>
      </div>
    );
  },

  _handleHidePopover() {
    const { popoverId } = this.props;
    PopoverActions.hide(popoverId);
  },

  _togglePopoverVisibility() {
    const { popoverId } = this.props;
    const { popoverVisibility } = this.state;

    if (popoverVisibility.get(popoverId)) return PopoverActions.hide(popoverId);
    PopoverActions.show(popoverId);
  },

  _getPopoverNode() {
    const { events, displayTitle } = this.props;

    const titleNode = displayTitle ? (
      <Col lg={24} md={24} sm={24}>
        <p className="ge-event-show-menu-title">Your events & shows</p>
      </Col>
    ) : null;

    return (
      <Popover
        style={{ left: 50 }}
        positionLeft={50}
        className="ge-popover ge-event-show-menu"
      >
        <Row>
          {titleNode}
          <Col lg={24} md={24} sm={24}>
            <EventCategorizedShowList
              {...{
                events,
                onShowClick: this._handleShowSelection,
                onEventClick: this._handleEventSelection,
              }}
            />
          </Col>
        </Row>
      </Popover>
    );
  },

  _handleShowSelection(event, show) {
    const { onShowClick } = this.props;
    this._togglePopoverVisibility();
    onShowClick(event, show);
  },

  _handleEventSelection(event) {
    const { onEventClick } = this.props;
    this._togglePopoverVisibility();
    onEventClick(event);
  },
});
